import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const AuthenticationPage = lazy(() => import("./AuthenticationPage"));

const AuthenticationPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <AuthenticationPage />
    </Suspense>
  );
};

export default AuthenticationPageLazy;
